/**
 * 1NOW-11127: the "Select All" box of a filter list (Car type, Category, Make, Model).
 *
 * It is not state of its own. It is ticked when every option is selected, or when none is
 * (no selection filters nothing, so it already means all of them), and unticked as soon as
 * only some are. It used to be a separate flag that "Clear" set to true and picking a class
 * never reset, so one class could be ticked beside a ticked "Select All".
 */
export const allSelected = (options: string[], selected: string[]): boolean =>
  selected.length === 0 || options.every((option) => selected.includes(option));

/** The selection after ticking or unticking one option. */
export const toggleOption = (selected: string[], option: string, on: boolean): string[] =>
  on ? (selected.includes(option) ? selected : [...selected, option]) : selected.filter((s) => s !== option);
